"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = __importDefault(require("../styles/theme"));
const flexbox = (props) => ({
    display: props.flex ? 'flex' : undefined,
    flexDirection: props.flexDirection,
    justifyContent: props.justifyContent,
    alignItems: props.alignItems,
});
const getSpacing = (size = 'none') => theme_1.default.spacing[size];
const spacing = (props) => ({
    paddingBottom: getSpacing(props.paddingBottom || props.paddingVertical || props.padding),
    paddingLeft: getSpacing(props.paddingLeft || props.paddingHorizontal || props.padding),
    paddingRight: getSpacing(props.paddingRight || props.paddingHorizontal || props.padding),
    paddingTop: getSpacing(props.paddingTop || props.paddingVertical || props.padding),
    marginBottom: getSpacing(props.marginBottom || props.marginVertical || props.margin),
    marginLeft: getSpacing(props.marginLeft || props.marginHorizontal || props.margin),
    marginRight: getSpacing(props.marginRight || props.marginHorizontal || props.margin),
    marginTop: getSpacing(props.marginTop || props.marginVertical || props.margin),
});
const size = (props) => ({
    maxWidth: props.maxWidth,
    width: props.width || props.size,
    height: props.height || props.size,
    background: props.background || 'transparent',
});
const additionalStyle = (props) => ({
    background: props.background || 'transparent',
    border: props.borderColor ? `1px solid ${props.borderColor}` : undefined,
    borderRadius: props.borderColor ? '7px' : undefined,
});
/**
 * Basic building block for layouts.
 */
exports.StyledDiv = styled_components_1.default.div `
  ${flexbox}
  ${spacing}
  ${size}
  ${additionalStyle}
`;
exports.default = exports.StyledDiv;
